import { endpoint } from 'services/endpoint';
import { http } from 'services/http';
import { TShopifyStoresApi } from './types';

export const shopifyStores: TShopifyStoresApi = {
	getStoresByClientId: (payload) =>
		http
			.get(endpoint.shopifyStores.GET_STORES_BY_CLIENT_ID, { params: payload })
			.then((response) => response.data),
	getStoreSettings: (payload) =>
		http.post(endpoint.shopifyStores.GET_STORE_SETTINGS, payload).then((response) => response.data),
	updateStoreSettings: (payload) =>
		http
			.post(endpoint.shopifyStores.UPDATE_STORE_SETTINGS, payload)
			.then((response) => response.data),
	getStoreSalesChannels: (payload) =>
		http
			.post(endpoint.shopifyStores.GET_STORE_SALES_CHANNELS, payload)
			.then((response) => response.data),
	updateStoreSalesChannels: (payload) =>
		http
			.post(endpoint.shopifyStores.UPDATE_STORE_SALES_CHANNELS, payload)
			.then((response) => response.data),
	syncStore: (payload) =>
		http.post(endpoint.shopifyStores.SYNC_STORE, payload).then((response) => response.data),
	listSalesChannelsCatalog: (payload) =>
		http
			.post(endpoint.shopifyStores.LIST_SALES_CHANNELS_CATALOG, payload)
			.then((response) => response.data),
	getSalesChannel: (channelId) =>
		http
			.post(endpoint.shopifyStores.GET_SALES_CHANNEL(channelId), { channelId })
			.then((response) => response.data),
	createSalesChannel: (payload) =>
		http
			.post(endpoint.shopifyStores.CREATE_SALES_CHANNEL, payload)
			.then((response) => response.data),
	updateSalesChannel: (payload) =>
		http
			.post(endpoint.shopifyStores.UPDATE_SALES_CHANNEL, payload)
			.then((response) => response.data),
	deleteSalesChannel: (payload) =>
		http
			.post(endpoint.shopifyStores.DELETE_SALES_CHANNEL, payload)
			.then((response) => response.data),
};
